import { render } from "./SelectedListElement.vue?vue&type=template&id=1db92561&ts=true"
import script from "./SelectedListElement.vue?vue&type=script&lang=ts"
export * from "./SelectedListElement.vue?vue&type=script&lang=ts"

import "./SelectedListElement.vue?vue&type=style&index=0&id=1db92561&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QBtn,QTooltip,QExpansionItem,QToggle});
